<template>
  <div class="pre-report">
    <div class="pre-report__title-wrap">
      <div class="pre-report__title">
        <svg
          class="icon-pre_report svg-icon"
          viewBox="0 0 27.49 21.276">
          <path
            class="color1"
            d="M2.75,7.05H2.64l.44,0ZM2.64,12.2h.44l-.33,0Zm8.89,5.59h0ZM26,0V19.24L4,
            12.37a5.47,5.47,0,0,0-.68-.14l-.21,0-.33,0H2.64l-.54.06-.25,0a4.32,4.32,0,0,
            0-.77.25L0,13V6.21l1.08.48a4.32,4.32,0,0,0,.77.25L2.1,7,2.64,7h.11l.33,
            0h.21A4.14,4.14,0,0,0,4,6.86Zm-1.5,2L4.41,8.3a5.86,5.86,0,0,1-1.66.25A5.84,
            5.84,0,0,1,1.5,8.41v2.42a5.84,5.84,0,0,1,1.25-.14,5.86,5.86,0,0,1,
            1.66.25L24.49,17.2ZM12.22,17.49a1,1,0,0,1-.29.2l-.09,0a1.08,1.08,0,0,
            1-.31.07h0a.9.9,0,0,1-.28,0l-2.3-.69a1,1,0,0,1-.7-.76L7.9,15l-2.29-.71.76,
            3.25a1.57,1.57,0,0,0,1,1.15l4.24,1.29a1.54,1.54,0,0,0,.43.06h0a2.09,2.09,
            0,0,0,.35,0l.09,0,.26-.11.09,0a1.7,1.7,0,0,0,.3-.23l2.2-2.27-2.27-.71Z" />
        </svg>速報デイリーレポート {{ item.date }}
      </div>
    </div>
    <div class="pre-report__streaming">
      <div class="pre-report__item-title">ストリーミング</div>
      <div class="pre-report__item-wrap">
        <div class="pre-report__item">
          <div class="pre-report__item-name"> </div>
          <div class="pre-report__item-count">
            {{ item.streaming }}
          </div>
        </div>
      </div>
    </div>
    <div class="pre-report__download">
      <div class="pre-report__item-title">ダウンロード</div>
      <div class="pre-report__item-wrap">
        <div class="pre-report__item">
          <div class="pre-report__item-name">単曲</div>
          <div class="pre-report__item-count">
            {{ item.single }}
          </div>
        </div>
        <div class="pre-report__item">
          <div class="pre-report__item-name">アルバム</div>
          <div class="pre-report__item-count">
            {{ item.album }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RealtimeReport',
  data() {
    return {
      item: {
        date: '',
        single: 0,
        album: 0,
        streaming: 0,
      },
    }
  },
  mounted() {
    this.fetchItem()
  },
  methods: {
    async fetchItem() {
      const config = { headers: { 'X-CMAP-No-Loading': 1 } }
      const { data } = await window.axios.get('/api/client/reports/realtime-summary', config)
      this.item.date = data.date ? `(${moment(data.date).format('MM月DD日分')})` : ''
      this.item.single = data.single
      this.item.album = data.album
      this.item.streaming = data.streaming
    },
  },
}
</script>
